import { gql } from '@apollo/client/core'

// ===== MEAL QUERIES =====
export const GET_MEALS = gql`
  query Meals {
    meals {
        id
        title
        description
        recipe_id
        type_id
        scheduled_date
        scheduled_dates
        portions_days
        portions_mode
        is_active
        created_at
        updated_at
    }
}
`

export const GET_MEAL = gql`
  query Meal($id: ID!) {
    meal(id: $id) {
        id
        title
        description
        recipe_id
        type_id
        scheduled_date
        scheduled_dates
        portions_days
        portions_mode
        created_at
        updated_at
    }
}
`

export const GET_MEALS_BY_DATE_RANGE = gql`
  query MealsByDateRange(
    $start_date: String!
    $end_date: String!
    $show_active: Boolean
  ) {
    mealsByDateRange(start_date: $start_date, end_date: $end_date, show_active: $show_active) {
        id
        title
        description
        recipe_id
        type_id
        scheduled_date
        scheduled_dates
        portions_days
        portions_mode
        is_active
        created_at
        updated_at
    }
}
`

export const GET_MEAL_TYPES = gql`
  query MealTypes {
    mealTypes {
      id
      name
      time
    }
  }
`

// ===== RECIPE QUERIES =====
export const GET_RECIPES = gql`
  query Recipes($limit: Int, $page: Int, $search: String) {
    recipes(limit: $limit, page: $page, search: $search) {
      id
      title
      slug
      description
      content
      category {
          id
          name
          created_at
          updated_at
      }
      created_at
      updated_at
      ingredients {
        id
        name
        quantity
        unit
      }
    }
  }
`

export const GET_RECIPE = gql`
  query Recipe($id: String!) {
    recipe(id: $id) {
      id
      title
      slug
      description
      content
      category {
          id
          name
          created_at
          updated_at
      }
      created_at
      updated_at
      ingredients {
        id
        name
        quantity
        unit
      }
    }
  }
`

export const GET_RECIPE_BY_SLUG = gql`
  query RecipeBySlug($slug: String!) {
    recipeBySlug(slug: $slug) {
      id
      title
      slug
      description
      content
      category {
          id
          name
          created_at
          updated_at
      }
      created_at
      updated_at
      ingredients {
        id
        name
        quantity
        unit
      }
    }
  }
`

// ===== SHOPPING LIST QUERIES =====
export const GET_SHOPPING_LISTS = gql`
  query ShoppingLists {
    shoppingLists {
      id
      title
      start_date
      end_date
      status
      total_price
      created_at
      updated_at
      items {
        id
        name
        quantity
        unit
        price
        is_bought
        type
      }
    }
  }
`

export const GET_SHOPPING_LIST = gql`
  query ShoppingList($id: String!) {
    shoppingList(id: $id) {
      id
      title
      start_date
      end_date
      status
      total_price
      created_at
      updated_at
      items {
        id
        name
        list_id
        ingredient_id
        quantity
        unit
        price
        is_bought
        type
        position
        created_at
        updated_at
      }
    }
  }
`

export const PREVIEW_MEALS_FOR_DATE_RANGE = gql`
  query PreviewMeals($start_date: String, $end_date: String) {
    previewMealsForDateRange(start_date: $start_date, end_date: $end_date) {
      meal_id
      meal_title
      scheduled_date
      recipe_id
      recipe_name
      ingredients {
        id
        name
        quantity
        unit
      }
    }
  }
`

export const FIND_INGREDIENTS_BY_DATE_RANGE = gql`
  query FindIngredientsByDateRange($start_date: String!, $end_date: String!) {
    findIngredientsByDateRange(start_date: $start_date, end_date: $end_date) {
      id
      name
      type
      quantity
      unit
      created_at
      updated_at
      group {
          id
          name
          created_at
          updated_at
      }
    }
  }
`

export const GET_SHOPPING_ITEMS = gql`
  query ShoppingItems {
    shoppingItems {
      id
      name
      list_id
      list_name
      ingredient_id
      quantity
      unit
      price
      is_bought
      type
      created_at
      updated_at
    }
  }
`

export const GET_SHOPPING_ITEM = gql`
  query ShoppingItem($id: String!) {
    shoppingItem(id: $id) {
      id
      name
      list_id
      list_name
      ingredient_id
      quantity
      unit
      price
      is_bought
      type
      created_at
      updated_at
    }
  }
`

export const GET_SHOPPING_ITEMS_BY_LIST = gql`
  query ShoppingItemsByList($list_id: String!) {
    shoppingItemsByList(list_id: $list_id) {
      id
      name
      list_id
      list_name
      ingredient_id
      quantity
      unit
      price
      is_bought
      type
      created_at
      updated_at
    }
  }
`

export const GET_INGREDIENT_GROUPS = gql`
  query getAllIngredientGroups {
    getAllIngredientGroups {
      id
      name
      created_at
      updated_at
    }
  }
`

// Updated queries based on your backend endpoints
export const GET_ALL_INGREDIENTS = gql`
  query GetAllIngredients {
    getAllIngredients {
      id
      name
      type
      quantity
      unit
      created_at
      updated_at
      group {
        id
        name
        created_at
        updated_at
      }
    }
  }
`

export const GET_INGREDIENT_BY_ID = gql`
  query GetIngredientByID($id: ID!) {
    getIngredientByID(id: $id) {
      id
      name
      type
      quantity
      unit
      created_at
      updated_at
      group {
        id
        name
        created_at
        updated_at
      }
    }
  }
`

export const GET_ALL_RECIPE_CATEGORIES = gql`
  query GetAllRecipeCategories {
    getAllRecipeCategories {
      id
      name
      created_at
      updated_at
    }
  }
`

export const GET_RECIPE_CATEGORY_BY_ID = gql`
  query GetRecipeCategoryByID($id: ID!) {
    getRecipeCategoryByID(id: $id) {
      id
      name
      created_at
      updated_at
    }
  }
`

// ===== USER QUERIES =====
export const GET_USER = gql`
  query User($id: String!) {
    user(id: $id) {
      id
      name
      email
      bio
      first_name
      last_name
      created_at
      updated_at
    }
  }
`

export const UPDATE_USER = gql`
  mutation UpdateUser(
    $id: String!
    $name: String
    $email: String
    $bio: String
    $first_name: String
    $last_name: String
  ) {
    updateUser(
      id: $id
      data: {
        name: $name
        email: $email
        bio: $bio
        first_name: $first_name
        last_name: $last_name
      }
    ) {
      id
      name
      email
      bio
      first_name
      last_name
      updated_at
    }
  }
`

// ===== STATS QUERIES =====
export const GET_TOP_COOKED_RECIPES = gql`
  query TopCookedRecipes($days: Int, $limit: Int) {
    topCookedRecipes(days: $days, limit: $limit) {
      recipeId
      title
      count
    }
  }
`

export const GET_TOP_BOUGHT_ITEMS = gql`
  query TopBoughtItems($days: Int, $limit: Int) {
    topBoughtItems(days: $days, limit: $limit) {
      name
      ingredientId
      count
      totalQuantity
      unit
    }
  }
`

// ===== TASK QUERIES =====
export const GET_TASKS = gql`
  query Tasks {
    tasks {
      id
      content
      project_id
      section_id
      description
      due_date
      labels
    }
  }
`

